import { DEVICE_CONNECTION_CONTEXT_MENU_SERVICE_NAME, DeviceConnectionsContextMenuServiceProvider } from './device-connections.context-menu.service'

export const DEVICE_CONNECTIONS_SERVICES_MODULE_NAME = 'simax.services.device-connection'

const module = angular.module(DEVICE_CONNECTIONS_SERVICES_MODULE_NAME, [])

module.provider(DEVICE_CONNECTION_CONTEXT_MENU_SERVICE_NAME, DeviceConnectionsContextMenuServiceProvider)
